<body id="dark" class="pt-20" style="padding-top:120px; min-height: 100vh;">

  <div class="col-md-6 mx-3 mt-4 text-start d-flex justify-content-between">
    <h5 class="text-color-theme">{{"local-market"|translate}}</h5>
    <div>
      <mat-button-toggle-group appearance="legacy" [(ngModel)]="activeEgx" (ngModelChange)="fetchEgx()">
        <mat-button-toggle class="text-color-theme" value="EGX30">EGX30</mat-button-toggle>
        <mat-button-toggle class="text-color-theme" value="EGX70EWI">EGX70</mat-button-toggle>
        <mat-button-toggle class="text-color-theme" value="EGX100EWI">EGX100</mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>

  <div class="demo-wrap">
    <div class="demo-content">
      <div class="row px-5 pt-2 flex-xs-column flex-sm-column flex-md-column flex-lg-row flex-xl-row">

        <div class="col-12 col-xl-6 col-lg-6" style="opacity: 0.9;">
          <div id="tradingview_bac65"></div>
        </div>
        <div class="col-12 col-xl-6 col-lg-6">
          <ngx-slick-carousel style="height: 100% !important;" class="carousel" #slickModal="slick-carousel"
            [config]="slideConfig">
            <div class=" page-background mat-elevation-z24 d-flex flex-row justify-content-between align-items-center rounded slide"
              ngxSlickItem style="height: 100% !important;direction: ltr !important;">
              <div style="max-width: 50%; min-width: 50%">
                <h6 class="text-color-theme text-center">{{"individial-vs-institutional"|translate}}</h6>
                <br>
                <div id="chart" *ngIf="individualChartOptions">
                  <apx-chart [colors]="colorScheme" [series]="individualChartOptions.series"
                    [chart]="individualChartOptions.chart" [labels]="individualChartOptions.labels"
                    [responsive]="individualChartOptions.responsive">
                  </apx-chart>
                </div>
              </div>

              <div style="max-width: 50%; min-width: 50%">
                <h6 class="text-color-theme text-center">{{"foreign-vs-domestic"|translate}}</h6>
                <br>
                <div id="chart" *ngIf="investorChartOptions">
                  <apx-chart [colors]="colorScheme" [series]="investorChartOptions.series"
                    [chart]="investorChartOptions.chart" [labels]="investorChartOptions.labels"
                    [responsive]="investorChartOptions.responsive"></apx-chart>
                </div>
              </div>
            </div>

            <div class=" page-background d-flex flex-row justify-content-between align-items-center rounded"
              style="height: 100% !important;"
              ngxSlickItem>
              <table class="table scrollable-table">
                <thead>
                  <tr>
                    <th style="text-align: center;">{{'investorsName'|translate}}</th>
                    <th style="text-align: center;">{{'investorsType'|translate}}</th>
                    <th style="text-align: center;">{{'buy'|translate}}</th>
                    <th style="text-align: center;">{{'sell'|translate}}</th>
                    <th style="text-align: center;">{{'turnover'|translate}}</th>
                    <th style="text-align: center;">{{'investorsNet'|translate}}</th>
                    <th style="text-align: center;">{{'investorsSide'|translate}}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let item of investorSummary">
                    <td style="text-align: center;">
                      {{(translate.currentLang=='en')?item['NAT_EN']:item['NAT']}}
                    </td>
                    <td style="text-align: center;">
                      {{(translate.currentLang=='en')?item['TTYPE_EN']:item['TTYPE']}}
                    </td>
                    <td style="text-align: center;">{{item['BUY'] | million}}</td>
                    <td style="text-align: center;">{{item['SELL'] | million}}</td>
                    <td style="text-align: center;">{{item['TURNOVER'] | million}}</td>
                    <td style="text-align: center;" [ngClass]="(item['NET']>0?'green':'red')">{{item['NET'] | million}}
                    </td>
                    <td style="text-align: center;" [ngClass]="(item['TRANSACTION_EN']=='Buy'?'green':'red')">
                      {{(translate.currentLang=='en')?item['TRANSACTION_EN']:item['TRANSACTION']}}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </ngx-slick-carousel>
        </div>
      </div>
    </div>
  </div>

  <br>

  <div class="ticker-bg ticker-border"
    style="border-radius: 5px; margin-top: 12px;margin-bottom: 12px;">
    <ngx-marquee style=" direction: ltr;" pauseOnHover="true" [duration]="'600s'">
      <div *ngFor="let item of news" style="display: inline-block; cursor: pointer;" class="p-1">
        <div class="text-color-theme px-2"><span
            class="news-date">{{item.DATE_STAMP|date:'mediumTime'}}</span>{{item.ARB_HEADING}}</div>
      </div>
    </ngx-marquee>
  </div>

  <br>
  <div class="row px-5 flex-xs-column flex-sm-column flex-md-column flex-lg-row flex-xl-row">
    <div class="col-12 col-xl-6 col-lg-6" id="recent-trades">
      <div class="green" style="text-align-last: start !important;">
        <h2><i class="ion-md-trending-up"></i> {{"TOP5"|translate}}</h2>
      </div>
      <table class="table">
        <thead>
          <tr style="padding-inline-end: 10px;">
            <th>{{"symbol"|translate}}</th>
            <th>{{"close"|translate}}</th>
            <th>{{"last-change-prc"|translate}}</th>
            <th>{{"volume"|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of top5Best">
            <td>{{(translate.currentLang=='en')?item.ENG_NAME:item.ARB_NAME}}</td>
            <td>{{item.CLOSE_PRICE | number: "1.0":"en-US"}}</td>
            <td [ngClass]="item.LAST_CHANGE_PRC>0? 'green' : 'red'">{{item.LAST_CHANGE_PRC | number: "1.0":"en-US"}} %
            </td>
            <td>{{item.TOTAL_VOLUME | number: "1.0":"en-US"}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="col-12 col-xl-6 col-lg-6" id="recent-trades">
      <div class="red" style="text-align-last: start !important;">
        <h2><i class="ion-md-trending-down"></i> {{"WORST5"|translate}}</h2>
      </div>
      <table class="table">
        <thead>
          <tr style="padding-inline-end: 10px;">
            <th>{{"symbol"|translate}}</th>
            <th>{{"close"|translate}}</th>
            <th>{{"last-change-prc"|translate}}</th>
            <th>{{"volume"|translate}}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of top5Worst">
            <td>{{(translate.currentLang=='en')?item.ENG_NAME:item.ARB_NAME}}</td>
            <td>{{item.CLOSE_PRICE | number: "1.0":"en-US"}}</td>
            <td [ngClass]="item.LAST_CHANGE_PRC>0? 'green' : 'red'">{{item.LAST_CHANGE_PRC | number: "1.0":"en-US"}} %
            </td>
            <td>{{item.TOTAL_VOLUME | number: "1.0":"en-US"}}</td>
          </tr>
        </tbody>

      </table>
    </div>
  </div>

</body>
